module.exports = __webpack_public_path__ + "static/media/STONE.480a925b.png";